import { render, staticRenderFns } from "./SelectPoint.vue?vue&type=template&id=679eed46"
import script from "./SelectPoint.vue?vue&type=script&lang=js"
export * from "./SelectPoint.vue?vue&type=script&lang=js"
import style0 from "./SelectPoint.vue?vue&type=style&index=0&id=679eed46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports